<template>
  <div id="dataSubmit">
    <Form ref="formItem" :model="formItem" :label-width="80" class="user-form" :rules="formRule">
      <FormItem label="课程" prop="course">
        <Input v-model="formItem.course" placeholder="课程"/>
      </FormItem>
      <FormItem label="标题" prop="title">
        <Input v-model="formItem.title" placeholder="标题"/>
      </FormItem>
      <FormItem label="结束时间" prop="endtime">
        <DatePicker v-model="formItem.endtime" type="date" placeholder="结束时间" format="yyyy年MM月dd日"></DatePicker>
      </FormItem>
      <FormItem label="作业内容" prop="content">
        <Input v-model="formItem.content" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="作业内容"/>
      </FormItem>
      <FormItem label="学生" prop="studentIds">
        <Select v-model="formItem.studentIds" filterable multiple>
          <Option v-for="item in students" :value="item.address" :key="item.address">
            {{ item.name }}-{{ item.school }}-{{ item.nianji }}-{{ item.banji }}
          </Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="submitNode()">作业发布</Button>
      </FormItem>
    </Form>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data () {
    return {
      spinShow: false,
      students: [],
      formItem: {
        course: '',
        title: '',
        endtime: '',
        studentIds: [],
        content: ''
      },
      formRule: {
        course: [
          {required: true, type: 'string', message: '请输入课程', trigger: 'blur'}
        ],
        title: [
          {required: true, type: 'string', message: '请输入标题', trigger: 'blur'}
        ],
        endtime: [
          {required: true, type: 'date', message: '请输入结束时间', trigger: 'blur'}
        ],
        studentIds: [
          {required: true, type: 'array', min: 1, message: '请选择学生', trigger: 'blur'}
        ],
        content: [
          {required: true, type: 'string', message: '请输入作业内容', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    submitNode: function () {
      var vueThis = this
      vueThis.$refs['formItem'].validate((valid) => {
        if (valid) {
          var f = vueThis.formItem
          let funcName = 'createHomework';
          let params = [f.course + '', f.title + '', vueThis.formItem.endtime.getTime(), f.content + '', f.studentIds];
          vueThis.spinShow = true
          vueThis.$store.dispatch('callNew', {funcName: funcName, params: params}).then((ret) => {
            vueThis.spinShow = false
            vueThis.showSuccess('发布作业成功');
            vueThis.$router.push('/homeworkMine')
          }, (error) => {
            vueThis.spinShow = false
            vueThis.showErr('发布作业失败' + error);
          });
        } else {
          vueThis.showErr('请完善表单必填字段');
        }
      })
    },
    getStudents: function () {
      var vueThis = this
      let funcName = 'getAllStudent';
      vueThis.spinShow = true
      vueThis.$store.dispatch('simulateCallNew', {funcName: funcName}).then((ret) => {
        vueThis.students = JSON.parse(ret);
        vueThis.spinShow = false
      }, (error) => {
        vueThis.spinShow = false
        vueThis.showErr('获取作业列表失败' + error);
      });
    }
  },
  created () {
    this.getStudents()
  },
  computed: mapState([
    'user'
  ])
}
</script>

<style>
  #dataSubmit {
  }
</style>



// WEBPACK FOOTER //
// src/components/base-homework-publish.vue